//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VButton from '@comp/parts/VButton.vue';
export default {
  name: 'ModalWithCancelButton',
  components: {
    VButton: VButton
  },
  methods: {
    open: function open() {
      this.$modal.show('modal-wrapper');
      document.getElementsByTagName('html')[0].classList.add('popup-opened');
    },
    close: function close() {
      this.$modal.hide('modal-wrapper');
      document.getElementsByTagName('html')[0].classList.remove('popup-opened');
    }
  }
};